// tslint:disable: prefer-for-of
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AlertController, MenuController, PopoverController } from '@ionic/angular';
import { ProductoMensajePopoverComponent } from 'src/app/components/productoMensajePopover/producto-mensaje-popover.component';
import { CarritoService } from 'src/app/services/carrito/carrito.service';
import { DeviceInfoService } from 'src/app/services/deviceInfo/device-info.service';

import { GlobalConstants } from 'src/app/services/globalConstants/global-constants.service';
import { GlobalFunctionsService } from 'src/app/services/globalFunctions/global-functions.service';
import { StorageService } from 'src/app/services/storage/storage.service';

import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { VisitaService } from 'src/app/services/visita/visita.service';

@Component({
  selector: 'app-carrito',
  templateUrl: './carrito.page.html',
  styleUrls: ['./carrito.page.scss'],
})
export class CarritoPage implements OnInit {

  //#region Propiedades

  public _appVersion: string;

  public _utmCampaign: string = null;
  public _utmContent: string = null;
  public _utmMedium: string = null;
  public _utmSource: string = null;
  public _utmTerm: string = null;
  public _total: number = 0;
  public _idCarrito: number;
  public _mostrarProductos: number = 3;

  public _listProduct: any;
  public _carrito: any;

  //#endregion Propiedades

  //#region Constructor

  constructor(private _route: ActivatedRoute,
              private _menuCtrl: MenuController,
              private _usuarioSrv: UsuarioService,
              private _visitaSrv: VisitaService,
              private _carritoSrv: CarritoService,
              public _alertController: AlertController,
              private _popoverCtrl: PopoverController,
              public storage: StorageService,
              private _router: Router,
              private _globalFunctionsSrv: GlobalFunctionsService) {

    console.log('CarritoPage >> constructor');
    this._listProduct = [];
  }

  //#endregion Constructor

  //#region Eventos NG

  public ngOnInit() {
    console.log('CarritoPage >> ngOnInit');
    this._menuCtrl.enable(false);
  }

  public async ionViewDidEnter() {

    console.log('CarritoPage >> ionViewDidEnter');

    this._appVersion = GlobalConstants.APP_VERSION;

    // recupera/crea/guarda token publico
    await this._usuarioSrv.doPublicToken();

    // await this._deviceSrv.getLocationInfo();

    /*this._deviceSrv.getLocationInfo().then((domi) => {
      console.log('el domi que se va a mandar es:');
      console.log(domi);
    });*/

    // registra visita
    await this._route.queryParams.subscribe((params) => {

      // recupera datos de UTM
      if (params['utm_campaign'] !== undefined) { this._utmCampaign = params['utm_campaign']; }
      if (params['utm_content'] !== undefined) { this._utmContent = params['utm_content']; }
      if (params['utm_medium'] !== undefined) { this._utmMedium = params['utm_medium']; }
      if (params['utm_source'] !== undefined) { this._utmSource = params['utm_source']; }
      if (params['utm_term'] !== undefined) { this._utmTerm = params['utm_term']; }

      this._visitaSrv.guardar('CarritoCompras', null, null,
        null, null, null, null,
        null, null,
        this._utmCampaign, this._utmContent, this._utmMedium, this._utmSource, this._utmTerm).subscribe();
      this.getCarrito();
    });
    await this._usuarioSrv.doPublicToken();
  }

  public async getCarrito(){
    this._carritoSrv.getCarritoWeb().subscribe(() => {
      this._carrito = this._carritoSrv.CurrentCarrito;
      this._idCarrito = this._carrito['IdCarrito'];
      this._listProduct = this._carrito['Productos'];
      this._total = this._carrito['Total'];
      if (this._listProduct && this._listProduct.length > 0){
        this._mostrarProductos = 1;
      }
      else{
        this._mostrarProductos = 0;
      }
    });
  }

  public async increment(item){
    this._carritoSrv.aumentarCantidadProducto(item['IdSucursal'], item['IdProductoWeb'], item['CodigoProducto'], item['Cantidad'], item['IdCarritoProducto']).subscribe(() => {
      if (this._carritoSrv.IncrementoValido == 1){
        item['Cantidad'] = item['Cantidad'] + 1;
        item['Subtotal'] = parseFloat(item['Subtotal']) + parseFloat(item['PrecioPublico']);
        this._globalFunctionsSrv.showMessageToast('Cantidad del Producto actualizada');
        this.recalculaTotal();
      }
      else{
        this._globalFunctionsSrv.showMessageToast('No hay existencia suficiente para aumentar la cantidad');
      }
    });
  }

  public async decrement(item){
    if (item['Cantidad'] <= 1){
      this.delete(item);
    }
    else{
      this._carritoSrv.disminuirCantidadProducto(item['Cantidad'], item['IdCarritoProducto']).subscribe(() => {
        if (this._carritoSrv.IncrementoValido == 1){
          item['Cantidad'] = item['Cantidad'] - 1;
          item['Subtotal'] = parseFloat(item['Subtotal']) - parseFloat(item['PrecioPublico']);
          this._globalFunctionsSrv.showMessageToast('Cantidad del Producto actualizada');
          this.recalculaTotal();
        }
      });
    }
  }

  public async delete(item){
    const alert = await this._alertController.create({
      header: 'Eliminar Producto',
      message: '¿Realmente desea eliminar este producto de su Carrito de Compras?',
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
          }
        },
        {
          text: 'Eliminar',
          handler: data => {
            this._carritoSrv.eliminarProducto(item['IdCarritoProducto']).subscribe(() => {
              if (this._carritoSrv.EliminacionValida == 1){
                const index = this._listProduct.indexOf(item);
                if (index > -1){
                    this._listProduct.splice(index, 1);
                  }
                this._globalFunctionsSrv.showMessageToast('Producto eliminado');
                this.recalculaTotal();
                this.validaCarito();
              }
            });
          }
        }
      ]
    });
    await alert.present();
  }

  public async tarjeta(item){
        const popover = await this._popoverCtrl.create({
          component: ProductoMensajePopoverComponent,
          componentProps: {
            '_idProductoCarritoWeb': item.IdCarritoProducto,
            '_mensajePrevio': item.MensajeTarjeta,
            '_productoTxt': item.NombreProductoWeb
          },
          cssClass: 'popoverExistencias',
          translucent: true
        });

        popover.onDidDismiss()
        .then((result) => {
          if (result['data']){
            item.MensajeTarjeta = result['data']['resp']['msg'];
          }
        });

        return await popover.present();

      }

  //#endregion Eventos NG

  //#region Eventos Botones

  public btnCheckout(){
    const userLogin = this.storage.getLogin();
    if (userLogin == 1){
      this._router.navigate(['/checkout']);
    }
    else{
      this._globalFunctionsSrv.showMessageToast('Debe iniciar sesión para continuar con su compra.');
      this._router.navigate(['/login']);
    }
  }

  public async btnVaciar(){
    const alert = await this._alertController.create({
      header: 'Vaciar carrito',
      message: '¿Realmente desea eliminar todos los productos de su Carrito de Compras?',
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
          }
        },
        {
          text: 'Vaciar',
          handler: data => {
            this._carritoSrv.vaciarCarrito(this._idCarrito).subscribe(() => {
              this._listProduct = [];
              this._mostrarProductos = 0;
              this._total = 0;
            });
          }
        }
      ]
    });

    await alert.present();
  }
  //#endregion

 // #Region Eventos Controles
  public validaCarito(){
    if (this._listProduct.length > 0){
      this._mostrarProductos = 1;
    }
    else{
      this._mostrarProductos = 0;
    }
  }

  private recalculaTotal(){
    this._total = 0;

    for (let i = 0; i < this._listProduct.length; i++) {
      this._total = this._total + parseFloat(this._listProduct[i]['Subtotal']);
    }
  }
    //#endregion

}
